const isNetworkError = (error) => {
  const response = error.response || {}

  return !response.status
}

const isApiError = (error) => {
  return error.response && !!error.response.status
}

export { isNetworkError, isApiError }
